
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/case-studies/[slug]",
      function () {
        return require("private-next-pages/case-studies/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/case-studies/[slug]"])
      });
    }
  